module.exports = __webpack_public_path__ + "static/media/building-websites.e480fa72.svg";